"use strict";

exports.__esModule = true;
exports.ResponsiveTile = void 0;

var _styled = require("../../styles/styled");

var _Core = require("../Core");

var ResponsiveTile = (0, _styled.styled)(_Core.Flex).withConfig({
  componentId: "sc-1wxgdb5-0"
})(["flex-basis:190px;"]);
exports.ResponsiveTile = ResponsiveTile;